import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { Box } from 'web-library';
import { AnnouncementNoticeBoardProps } from 'web-library/models/Announcements';
import MobileNoticeBoard from './MobileNoticeBoard';
import DesktopNoticeBoard from './DesktopNoticeBoard';

const AnnouncementNoticeBoard = ({
  announcementDetailPage,
  announcementConfig,
}: AnnouncementNoticeBoardProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      {isMobile ? (
        <MobileNoticeBoard
          announcementConfig={announcementConfig}
          announcementDetailPage={announcementDetailPage}
        />
      ) : (
        <DesktopNoticeBoard
          announcementConfig={announcementConfig}
          announcementDetailPage={announcementDetailPage}
        />
      )}
    </Box>
  );
};

export default AnnouncementNoticeBoard;
